const $ = window.jQuery;

$(document).ready(function () {

  // Number Counter
  const $counters = $('.counter-block');

  if ($counters.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const $numbers = $(entry.target).find('span.integer__');

        $numbers.each(function () {
          const $this = $(this);

          // Remove commas to get a clean numeric value
          const finalValue = parseInt($this.text().replace(/,/g, ''), 10);

          $this.prop('Counter', 0).animate(
            { Counter: finalValue },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                // Format with commas while animating
                $this.text(Math.ceil(now).toLocaleString('en'));
              },
            }
          );
        });

        // Trigger once
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    $counters.each(function () { observer.observe(this); });
  }


  // Accordion
  // ------------------------
  $('.accordion-block').each(function () {
    const $items = $(this).find('.accordion-each');
    if (!$items.length) return;

    $items.first().addClass('open').find('.accordion-text').show();

    $(this).on('click', '.accordion-each', function (e) {
      e.stopPropagation();
      const $clicked = $(this);
      $clicked.toggleClass('open').find('.accordion-text').stop(true, true).slideToggle(300);
      $items.not($clicked).removeClass('open').find('.accordion-text').stop(true, true).slideUp(300);
    });
  });



// Popular Product Slider

if ($('.custom-popular--product .single-slider').length) {
  const $slider = $('.custom-popular--product .single-slider');

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.popular-prduct--prev').on('click', function () {
    $slider.slick('slickPrev');
  });

  $('.popular-prduct--next').on('click', function () {
    $slider.slick('slickNext');
  });
}


// Written Testimonial Slider

if ($('.custom-written-testimonial-slider .testimonial-content-slider').length) {
  const $slider = $('.custom-written-testimonial-slider .testimonial-content-slider');

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    adaptiveHeight: true
  });

  $('.custom-written-testimonial-slider .written-testimonial--prev').on('click', function () {
    $(this).closest('.custom-written-testimonial-slider').find('.testimonial-content-slider').slick('slickPrev');
  });

  $('.custom-written-testimonial-slider .written-testimonial--next').on('click', function () {
    $(this).closest('.custom-written-testimonial-slider').find('.testimonial-content-slider').slick('slickNext');
  });
}


// Brand Category Card - make entire card clickable
$('.brand-category-card').on('click', function (e) {
  const $link = $(this).find('.section-btn a');
  if (!$link.length) return;

  // If the actual button link was clicked, let it behave normally
  if ($(e.target).closest('.section-btn a').length) return;

  window.location.href = $link.attr('href');
});


// Related Product


(function () {
  const $slider = $('.custom-related--product .single-slider');

  if ($slider.length) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
       adaptiveHeight: true,
      variableWidth: true, 

      responsive: [
        {
          breakpoint: 600,
          centerMode: true ,
          settings: {
            variableWidth: false
          }
        }
      ]
    });

    $('.popular-prduct--prev').on('click', function () {
      $slider.slick('slickPrev');
    });

    $('.popular-prduct--next').on('click', function () {
      $slider.slick('slickNext');
    });
  }
})();

//Brand Accordion

function initBrandAccordion() {
    // Default active (scoped per container so mobile also gets a first active item)
    $(".content-block.block-1 .accordion-title").each(function () {
        $(this).find(".accordion-logo").removeClass("active")
            .first().addClass("active");
    });

    $(".content-block.block-2 .accordion-brand--each").removeClass("active")
        .first().addClass("active");

    // Click handler
    $(document).on("click", ".content-block.block-1 .accordion-title .accordion-logo", function () {
        var index = $(this).data("index");

        // Toggle active on logos
        $(".content-block.block-1 .accordion-title .accordion-logo").removeClass("active");
        $(this).addClass("active");

        // Toggle active on panels
        $(".content-block.block-2 .accordion-brand--each").removeClass("active");
        $('.content-block.block-2 .accordion-brand--each[data-index="' + index + '"]').addClass("active");
    });
}

$(document).ready(function () {
    initBrandAccordion();
});




$('.section-media, .custom-media--wrapper').each(function() {
  var $section = $(this);
  var $btn = $section.find('.custom-play-btn');
  var $video = $section.find('video');

  if ($video.length && $btn.length) {
    var videoEl = $video[0];

    // When video ends
    videoEl.addEventListener('ended', function() {
      videoEl.muted = true;             
      $video.removeAttr('controls');    
      $btn.fadeIn(200);                  
      $section.removeClass('playing');    
    });

    // Play with sound button
    $btn.on('click', function() {
      videoEl.currentTime = 0;
      videoEl.muted = false;             
      $video.attr('controls', true);      
      $section.addClass('playing');

      var playPromise = videoEl.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {});
      }

      $btn.fadeOut(200); 
    });
  }
});



 
function initImageSliders() {
  var $sliderFor = $('.custom-slider-for');
  var $sliderNav = $('.custom-slider-nav');

  if ($sliderFor.length && $sliderNav.length) {

    // destroy if already initialized
    if ($sliderFor.hasClass('slick-initialized')) $sliderFor.slick('unslick');
    if ($sliderNav.hasClass('slick-initialized')) $sliderNav.slick('unslick');

    // init main slider
    $sliderFor.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.custom-slider-nav'
    });

    // init nav slider
    $sliderNav.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.custom-slider-for',
      focusOnSelect: true,
      arrows: false
    });

    // 🔥 CUSTOM ARROWS (your markup)
    $('.prev-button').off('click').on('click', function () {
      $sliderFor.slick('slickPrev');
    });

    $('.next-button').off('click').on('click', function () {
      $sliderFor.slick('slickNext');
    });
  }
}

$(document).ready(function () {
  initImageSliders();
});

document.addEventListener('shopify:section:load', initImageSliders);







/// Scroll Anitmation

function animateOnScroll(selector = '.animate-on-scroll', stagger = 0.15) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const $item = $(entry.target);
        const $section = $item.closest('.section-wrapper');
        const $itemsInSection = $section.find(selector);
        const index = $itemsInSection.index($item);
        const delay = (index * stagger).toFixed(2) + 's';

        $item.css('animation-delay', delay);

        $item.addClass('visible');

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  $(selector).each(function() {
    observer.observe(this);
  });
}

// Init
animateOnScroll('.animate-on-scroll', 0.15);







  //Tab Accordion

  $('.custom-tabs-accordion').each(function () {
    const $section = $(this);
    const $tabLinks = $section.find('.tab-link');
    const $tabContents = $section.find('.tab-content');
    const $tabSelect = $section.find('.tabs-nav-select');

    $tabContents.hide().removeClass('active');
    $tabLinks.removeClass('active');

    $tabLinks.first().addClass('active');
    $tabContents.first().addClass('active').show();

    $tabLinks.on('click', function (e) {
      e.preventDefault();
      const tabId = $(this).data('tab');

      $tabLinks.removeClass('active');
      $(this).addClass('active');

      $tabContents.removeClass('active').hide();
      const $activeTab = $section.find('#' + tabId);
      $activeTab.addClass('active').show();

      const $accordions = $activeTab.find('.tab-accordion-each');
      $accordions.removeClass('open').find('.tab-accordion-text').hide();
      $accordions.first().addClass('open').find('.tab-accordion-text').show();

      // Sync select dropdown
      if ($tabSelect.length) {
        $tabSelect.val(tabId);
      }
    });

    // Mobile select dropdown handler
    $section.on('change', '.tabs-nav-select', function () {
      const tabId = $(this).val();

      $tabLinks.removeClass('active');
      $section.find('.tab-link[data-tab="' + tabId + '"]').addClass('active');

      $tabContents.removeClass('active').hide();
      const $activeTab = $section.find('#' + tabId);
      $activeTab.addClass('active').show();

      const $accordions = $activeTab.find('.tab-accordion-each');
      $accordions.removeClass('open').find('.tab-accordion-text').hide();
      $accordions.first().addClass('open').find('.tab-accordion-text').show();
    });

    $section.find('.tab-accordion--block').each(function () {
      const $items = $(this).find('.tab-accordion-each');
      if (!$items.length) return;

      if ($(this).closest('.tab-content').hasClass('active')) {
        $items.first().addClass('open').find('.tab-accordion-text').show();
      }

      $(this).on('click', '.tab-accordion-each', function () {
        const $clicked = $(this);


        $clicked.toggleClass('open')
          .find('.tab-accordion-text')
          .stop(true, true)
          .slideToggle(300);

        $items.not($clicked)
          .removeClass('open')
          .find('.tab-accordion-text')
          .stop(true, true)
          .slideUp(300);
      });
    });
  });



function initLogoSlider() {
  var $slider = $('.custom-logo--block .logo-content--inner');

  if (window.innerWidth <= 750) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,    
        speed: 6000,           
        cssEase: 'linear',     
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,         
        draggable: false,
        variableWidth: true    
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

$(document).ready(function () {
  initLogoSlider();
  $(window).on('resize', initLogoSlider);
});

  $('.art-tabs').each(function() {
    var $tabsContainer = $(this);

    $tabsContainer.find('.tab-buttons li').on('click', function() {
      var $btn = $(this);

      // Remove active class from all buttons in this container
      $tabsContainer.find('.tab-buttons li').removeClass('active');
      $btn.addClass('active');

      // Remove active class from all tab contents in this container
      $tabsContainer.find('.tab-content').removeClass('active');

      // Add active class to the clicked tab content
      var tabId = $btn.data('tab');
      $tabsContainer.find('#' + tabId).addClass('active');
    });
  });


  // Custom Image Slider - Seamless Infinite Loop
  // ------------------------
  function setupMarqueeTracks() {
    $('.custom-image--slider').each(function() {
      const $slider = $(this);
      const $tracks = $slider.find('.marquee-track');

      $tracks.each(function() {
        const $track = $(this);
        const $items = $track.find('.image-each');
        
        if ($items.length < 3) return;

        // Calculate width of one set (including gaps)
        const totalWidth = $track[0].scrollWidth;
        const oneSetWidth = totalWidth / 3;

        // Set CSS variable for exact animation distance
        $track.css('--marquee-distance', `-${oneSetWidth}px`);
      });
    });
  }

  // Run immediately and after images are loaded
  setupMarqueeTracks();
  $(window).on('load', setupMarqueeTracks);
  
  // Also run on resize
  $(window).on('resize', setupMarqueeTracks);

  // Force white text on app-injected "Get a quote" button in default product template
  if (document.querySelector('main[data-template="product"]')) {
    const quoteButtonSelector = '[id^="get-a-quote-cfp-button_"]';

    function fixQuoteButtonText() {
      document.querySelectorAll(quoteButtonSelector).forEach(function (button) {
        button.style.setProperty('color', '#FFFFFF', 'important');
        button.style.setProperty('-webkit-text-fill-color', '#FFFFFF', 'important');
        button.querySelectorAll('*').forEach(function (child) {
          child.style.setProperty('color', '#FFFFFF', 'important');
          child.style.setProperty('-webkit-text-fill-color', '#FFFFFF', 'important');
        });
      });
    }

    fixQuoteButtonText();

    const quoteObserver = new MutationObserver(function (mutations) {
      const hasButton = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          return (node.matches && node.matches(quoteButtonSelector)) ||
            (node.querySelector && node.querySelector(quoteButtonSelector));
        });
      });
      if (hasButton) fixQuoteButtonText();
    });

    const productDetails = document.querySelector('.product-details') || document.querySelector('main');
    if (productDetails) {
      quoteObserver.observe(productDetails, { childList: true, subtree: true });
    }
  }

  /*
  // Add "As Low As" before WSAIO price and "Per Unit" after - only on default product template
  if (document.querySelector('main[data-template="product"]')) {
    function addPriceLabels() {
      // Handle WSAIO prices
      const wsaioPrices = document.querySelectorAll('.wsaio_productPriceOriginal, .wsaio_productPriceDiscounted');
      wsaioPrices.forEach(function (container) {
        // Add "As Low As" before price
        if (!container.querySelector('.wsaio-as-low-as')) {
          const priceSpan = container.querySelector('.price');
          if (priceSpan) {
            const asLowAsSpan = document.createElement('span');
            asLowAsSpan.className = 'wsaio-as-low-as';
            asLowAsSpan.textContent = 'As Low As ';
            priceSpan.parentNode.insertBefore(asLowAsSpan, priceSpan);
          }
        }

        // Add "Per Unit" after price
        if (!container.querySelector('.wsaio-per-unit')) {
          const priceSpan = container.querySelector('.price');
          if (priceSpan) {
            const perUnitSpan = document.createElement('span');
            perUnitSpan.className = 'wsaio-per-unit';
            perUnitSpan.textContent = ' Per Unit';
            priceSpan.parentNode.insertBefore(perUnitSpan, priceSpan.nextSibling);
          }
        }
      });

      // Handle standard Shopify prices
      const shopifyPrices = document.querySelectorAll('product-price .price-item--sale');
      shopifyPrices.forEach(function (priceSpan) {
        const container = priceSpan.closest('product-price');
        if (!container.querySelector('.wsaio-as-low-as')) {
          const asLowAsSpan = document.createElement('span');
          asLowAsSpan.className = 'wsaio-as-low-as';
          asLowAsSpan.textContent = 'As Low As ';
          priceSpan.parentNode.insertBefore(asLowAsSpan, priceSpan);
        }

        if (!container.querySelector('.wsaio-per-unit')) {
          const perUnitSpan = document.createElement('span');
          perUnitSpan.className = 'wsaio-per-unit';
          perUnitSpan.textContent = ' Per Unit';
          priceSpan.parentNode.insertBefore(perUnitSpan, priceSpan.nextSibling);
        }
      });
    }

    // Run immediately
    addPriceLabels();

    // Also run after a delay to catch late-injected content
    setTimeout(addPriceLabels, 1000);
    setTimeout(addPriceLabels, 2000);

    // Use MutationObserver to catch dynamic changes
    const priceObserver = new MutationObserver(function (mutations) {
      addPriceLabels();
    });

    const productPriceContainer = document.querySelector('product-price') || document.querySelector('.product-details') || document.body;
    if (productPriceContainer) {
      priceObserver.observe(productPriceContainer, { childList: true, subtree: true });
    }
  }
  */

});
